import moment from 'moment-timezone'
import  store  from '../store'

export  function getDate(date) {

    const getZoneFromOffset = offsetString => moment.tz.names().filter(tz => moment.tz(tz).format('Z') === offsetString)
    var tempDate = moment.tz(date, getZoneFromOffset(store.state.auth.user.systemTimezone)[0]);
    var dateZone = tempDate.clone().tz(store.state.auth.user.userTimeZone); 

    return dateZone;
  }